import last from 'lodash/last';
import { useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { BrandContext, TEMPO } from 'context/BrandContext';
import { FAMILY_MENU_PATH } from 'helpers/routes';
import useBrand from 'hooks/useBrand';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';
import { FAMILY } from 'lib/constants';

const Logo = () => {
  const location = useLocation();
  const { brand } = useContext(BrandContext);
  const isTempo = useBrand(TEMPO);
  const [logo, setLogo] = useState(null);
  const { isMobileOrTablet } = useScreenSizeConstants();

  const mealPlanSlug = last(location.pathname.split('/'));
  const linkPath = mealPlanSlug === FAMILY ? FAMILY_MENU_PATH : '/';

  useEffect(() => {
    if (!brand) return;
    const image = require(`images/logo/${brand}.svg`);
    setLogo(image);
  }, [brand]);

  const logoDimensions = {
    width: isTempo ? (isMobileOrTablet ? '70' : '100') : '35',
    height: isTempo ? (isMobileOrTablet ? '36' : '34') : '37',
  };

  return (
    <a href={linkPath}>
      <img
        src={logo}
        width={logoDimensions.width}
        height={logoDimensions.height}
        alt={`${brand} logo`}
      />
      <span className="sr-only">Go to home page</span>
    </a>
  );
};

export default Logo;
